import * as React from 'react';
import {useDispatch} from 'react-redux';

import {convertToArray} from 'nutshell-core/filter';
import type {FilterObject} from 'nutshell-core/types';

import * as actions from '../../../email-marketing/analytics/report/analytics-actions';
import {AnalyticsReportChart} from '../../../email-marketing/analytics/report/analytics-report-chart';
import {VISITORS} from '../../../reports/report-constants';
import {ReportDataSummary} from '../../../reports/report-data-summary';
import type {ChartReportParams, ReportURLParams} from '../../../reports/report-types';

type Props = {
    activeFilters: FilterObject[];
    onChartClick?: (filters: FilterObject) => void | null | undefined;
    onParamChange: (arg1: any, arg2: boolean) => void;
    reportParams: ChartReportParams;
    urlParams: ReportURLParams<any>;
    currentGapIndex: number;
};

export function VisitorsChart(props: Props) {
    const dispatch = useDispatch();

    const period = (props.urlParams.filter && props.urlParams.filter.createdTime) || '-d30';
    const activeFilters = convertToArray({period});

    const reportParams = {
        ...props.reportParams,
        dateRangeType: 'period',
        facet: 'count',
        segment: 'interactionType',
    } as const;

    const activeFiltersString = JSON.stringify(activeFilters);
    const reportParamsString = JSON.stringify(reportParams);

    // eslint-disable-next-line react-hooks/exhaustive-deps
    const memoizedActiveFilters = React.useMemo(() => activeFilters, [activeFiltersString]);

    // eslint-disable-next-line react-hooks/exhaustive-deps
    const memoizedReportParams = React.useMemo(() => reportParams, [reportParamsString]);

    const fetchAnalyticsReportData = React.useCallback(() => {
        dispatch(
            actions.requestSiteAnalyticsReportData({
                reportParams: memoizedReportParams,
                filters: memoizedActiveFilters,
            })
        );
    }, [dispatch, memoizedReportParams, memoizedActiveFilters]);

    React.useEffect(() => {
        fetchAnalyticsReportData();
    }, [fetchAnalyticsReportData, memoizedReportParams, memoizedActiveFilters]);

    const reportDataSummary = (
        <ReportDataSummary
            currentGapIndex={props.currentGapIndex}
            filterParams={props.urlParams.filter}
            reportParams={reportParams}
            reportKey={VISITORS}
        />
    );

    return (
        <AnalyticsReportChart
            activeFilters={props.activeFilters}
            onChartClick={props.onChartClick}
            onParamChange={props.onParamChange}
            reportParams={reportParams}
            // @ts-expect-error
            reportKey={VISITORS}
            hasGap={true}
            hasBorder={false}
            isFullWidth={true}
            reportDataSummary={reportDataSummary}
        />
    );
}
